import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCurrency } from '../../Constant'
import axios from 'axios'
import Toggle from 'react-toggle'
import { Link } from 'react-router-dom'
import Loader from '../../common/Loader'

class JourneyAddEdit extends React.Component {
  state = {
    type: 'add',
    id: '',

    name: '',
    duration: 1,
    base_wallet_amount: 1,
    increment_by_day: 1,
    max_days: 1,
    is_active: true,

    is_loading: false,
  }

  handleChange = (event) => {
    if (event.target.name == 'is_active') {
      this.setState({ is_active: event.target.checked })
    } else {
      this.setState({ [event.target.name]: event.target.value })
    }
  }

  componentDidMount() {
    if (this.props.match.params.type && this.props.match.params.id) {
      this.setState(
        {
          type: this.props.match.params.type,
          id: this.props.match.params.id,
        },
        () => {
          this.getData(this.props.match.params.id)
        }
      )
    }
  }

  getData = async (id) => {
    this.setState({
      is_loading: true,
    })

    await axios
      .get(Constant.getAPI() + `/admin/journey-list/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res.status === 200) {
          let data = res.data.data

          this.setState({
            id: data.id,
            base_wallet_amount: data.base_wallet_amount,
            country: data.country,
            duration: data.duration,
            increment_by_day: data.increment_by_day,
            max_days: data.max_days,
            name: data.name,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          is_loading: false,
        })
      })
  }

  onSaveData = () => {
    let data = {
      name: this.state.name,
      duration: this.state.duration,
      base_wallet_amount: this.state.base_wallet_amount,
      increment_by_day: this.state.increment_by_day,
      max_days: this.state.max_days,
      is_active: this.state.is_active,
      country: localStorage.getItem('countryShortName'),
    }

    if (this.state.type == 'edit') {
      data.id = this.state.id
      data.country = this.state.country
    }

    this.setState({
      is_loading: true,
    })

    axios
      .post(Constant.getAPI() + '/admin/save-journey', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status) {
          Swal.fire({
            title: 'Item Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/journey-list`
      })
      .catch((err) => {
        this.setState({ isSaving: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          is_loading: false,
        })
      })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Journey {this.props.match.params.type}</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/journey-list`}> Journey List</Link>
                    </li>
                    <li className="breadcrumb-item active">Journey {this.props.match.params.type}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <Loader
              open={this.state.is_loading}
              fullPage={true}
            />
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Name</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              id="name"
                              placeholder="Enter Name"
                              onChange={this.handleChange}
                              value={this.state.name}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Duration(Monthly)</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              id="duration"
                              placeholder="Enter number"
                              onChange={this.handleChange}
                              value={this.state.duration}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Base Wallet Amount({getCurrency(localStorage.getItem('countryShortName'))})
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="base_wallet_amount"
                              id="base_wallet_amount"
                              placeholder="Enter number"
                              onChange={this.handleChange}
                              value={this.state.base_wallet_amount}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Amount increased by day({getCurrency(localStorage.getItem('countryShortName'))})
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="increment_by_day"
                              id="increment_by_day"
                              placeholder="Enter number"
                              onChange={this.handleChange}
                              value={this.state.increment_by_day}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Max days</label>
                          <div className="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              name="max_days"
                              id="max_days"
                              placeholder="Enter number"
                              onChange={this.handleChange}
                              value={this.state.max_days}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Is Active</label>
                          <div className="col-sm-9">
                            <Toggle
                              className="ml-2 form-control"
                              name="is_active"
                              id="is_active"
                              onChange={this.handleChange}
                              checked={this.state.is_active}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row float-right p-3">
                      {this.state.is_loading ? (
                        <button
                          className="btn btn-grd-disabled mr-2"
                          disabled
                        >
                          Saving...!
                        </button>
                      ) : (
                        <button
                          onClick={this.onSaveData}
                          className="btn hor-grd btn-grd-inverse"
                        >
                          <i className="icofont icofont-save"></i> Save
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default JourneyAddEdit
